import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

interface ItemProps {
  index: number;
  item: { value: string; label: string };
}

export const Item: React.FC<ItemProps> = ({ index, item: { label, value } }) => {
  const flexSize = index % 2 === 0 ? 1 : 0.3;

  return (
    <VStack flex={flexSize} color={'amber.300'} pt={Spacing['inline.xxxs']}>
      <Text fontSize={Typography['fontsize.xs']} variant="semibold" color="neutral.black">
        {label}
      </Text>
      <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.black">
        {value}
      </Text>
    </VStack>
  );
};
